
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import ExpandIcon from "@/components/utils/ExpandIcon.vue";

import "@/store/modules/forms/form5";
import { GetInstructionFile } from '@/components/utils/GetInstructionFile';
const form5State = namespace("Form5");

@Component({
    components:{
        ExpandIcon
    }
})
export default class NoticeOfHearingAppRightToAppealPg extends Vue {

    @form5State.Action
	public UpdateCurrentNoticeOfHearingOfAppealId!: (newCurrentNoticeOfHearingOfAppealId: string) => void        


    showReadyInfo = true;
    showHearingInfo = false;

    public showReady(show: boolean){
        if (show) {
            this.showReadyInfo = true;
            this.$emit('adjustHeights', 0, "31rem");
        } else {
            this.showReadyInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showHearing(show: boolean){
        if (show) {
            this.showHearingInfo = true;
            this.$emit('adjustHeights', 1, "16rem");
        } else {
            this.showHearingInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }   

    public startNewForm5Document(){
        this.UpdateCurrentNoticeOfHearingOfAppealId(null);            
        this.$router.push({name: "start-form5" })
    }

    public downloadInstructions(pdf_name){

        GetInstructionFile(pdf_name);
        
    }

}
